import axios from '@/http'


// 修改用户信息
export function updateUserInfo(data) {
    return axios({
        url: '/api/jp/update-user-info',
        method: 'POST',
        data
    })
}